export const BASE_URL = 'https://api.reactdeveloper.ir/api/v1/';
export default {
  regitser: BASE_URL + 'user/register',
  login: BASE_URL + 'user/login',
  getCourses: BASE_URL + 'courses',
};
